export default __webpack_public_path__ + "static/media/edu_logo.f318fce1.png";